import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import store from './store/index.js'
import './assets/js/global.js'
import './assets/js/axios.js'

import './assets/css/reset.css'
import './assets/css/global.css'
import './assets/css/cover.css'


import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(VueQuillEditor)
Vue.use(ElementUI)
Vue.use(Vuex)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
})



/**
 * 
 * 首次进入页面的逻辑
 * 
 *     1. 取出 token  在 全局前置守卫 中发起请求  判断 token 是否过期
 *          过期：清除 vuex 中的用户信息 、token 值
 *          没过期：则正常访问
 *     2. 发起请求 判断 返回的状态码  约定为 403  
 *          403 ： token 过期 - 清除 vuex 中的用户信息 、token 值
 *               并记录当前页面地址 跳转至登录页  登录成功  记录用户信息、token、返回用户访问的页面
 * 
 *     3. 每次跳转 都要 判断 localStorage 中是否存有 token 或 是否过期   --  没有则跳转至登录页
 * 
 * 
 * 
 * 
 * 
 * 
 */


// WEBPACK FOOTER //
// ./src/main.js